import React from 'react';
import TableWrapper from '../elements/TableWrapper';
import img from './../../assets/img/At the office-pana 1.png';
import MiCompAPI from '../../util/api';
import moment from 'moment';




import {
    Layout, message, Row, Col, Modal
} from 'antd';
import BrokerInvitation from './BrokerInvitation';
const { Content } = Layout;
const { confirm } = Modal;
class Invitations extends React.Component {
    constructor(props) {
        super(props);      
        const { decodedToken } = this.props.userPermandMasters;
        var role = decodedToken.UserRoleName;
        this.tableButtons = [];
        if(role==='carrier'){
            this.tableButtons.push({
                buttonType: "primary",
                content: "Invite",
                clickHandler: () => {
                    this.addDefaultHandler();
                }
            })
        }
       this.columns=[{
                title: 'Entity Name',
                dataIndex: 'name'   ,
                sorter: (a, b) => a.name.localeCompare(b.name),
                sortDirections: ["descend", "ascend"]            
            },
            {
                title: 'Entity Type',
                dataIndex: 'entity_Type',
                sorter: (a, b) => a.entity_Type.localeCompare(b.entity_Type),
                sortDirections: ["descend", "ascend"]
            },
            {
                title: 'Email',
                dataIndex: 'email',
                sorter: (a, b) => a.email.localeCompare(b.email),
                sortDirections: ["descend", "ascend"]
            },
            {
                title: 'Status',
                dataIndex: '',
                render: (text, record) => {return (record.isActive?'Submitted':'Accepted')}
            }             

       ];
        this.columns_ = [{
            title: 'Entity Type',
            dataIndex: 'entity_Type',
            sorter: (a, b) => a.entity_Type.localeCompare(b.entity_Type),
            sortDirections: ["descend", "ascend"]
        },
        {
            title: 'Entity Name',
            dataIndex: 'entity_Name',
            sorter: (a, b) => a.entity_Name.localeCompare(b.entity_Name),
            sortDirections: ["descend", "ascend"]
        },
        {
            title: 'Request By',
            dataIndex: 'request_By',
            sorter: (a, b) => a.request_By.localeCompare(b.request_By),
            sortDirections: ["descend", "ascend"]
        },
        {
            title: 'Date of Request',
            dataIndex: 'date_of_Request',
            render: (text, record) =>
                record["date_of_Request"] !== null && record["date_of_Request"] !== ""
                    ? moment(record["date_of_Request"]).format("MM/DD/YYYY")
                    : "",
            sorter: (a, b) => a.date_of_Request.localeCompare(b.date_of_Request),
            sortDirections: ["descend", "ascend"]
        },
        {
            title: 'LOA',
            dataIndex: 'loa',
            sorter: (a, b) => a.loa.localeCompare(b.loa),
            sortDirections: ["descend", "ascend"]
        }, {
            title: 'State',
            dataIndex: 'state',
            sorter: (a, b) => a.state.localeCompare(b.state),
            sortDirections: ["descend", "ascend"]
        },
        {
            title: 'Status',
            dataIndex: 'status',
            sorter: (a, b) => a.status.localeCompare(b.status),
            sortDirections: ["descend", "ascend"]
        },
        {
            title: 'Actions',
            dataIndex: '',
            render: (text, record) => {
                return (


                    <div >
                        {record.to_Id === record.loggedIn_Id && record.status === "Initiated" && (role === "carrier" || (this.state.validation && this.state.validation[record.entity_Type.toLowerCase()])) ? <>
                            <i onClick={() => this.showConfirmAcceptInvite(record)} className="fa fa-check fa-blue" ></i>
                            <i onClick={() => this.showConfirmDeclineInvite(record)} className="fa fa-times fa-red" ></i>

                        </> :
                            <></>}

                    </div>



                );
            },


        }
        ];

        this.state = {
            allInvitationsLoading: true,
            validation: null,
            addInvite: false
        }
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    componentDidMount() {
        this.getInvitations();
        this.getInvitations_();

    }
    addDefaultHandler = () => {
        this.setState({ addInvite: !this.state.addInvite });
    };
    showConfirmAcceptInvite = (record) => {
        confirm({
            title: 'Do you want to Accept this Invitation?',
            onOk: () => this.AcceptInvite(record),
            okText: "yes",
            cancelText: "No",
            onCancel() { },
        });
    }
    showConfirmDeclineInvite = (record) => {
        confirm({
            title: 'Do you want to Decline this Invitation?',

            onOk: () => this.DeclineInvite(record),
            okText: "yes",
            cancelText: "No",
            onCancel() { },
        });
    }
    addSubmitHandler = (values) => {
        this.setState({
            isloading: true
        });
        if(values.etype==="B"){
            this.api.invoke("UpsertBrokerInvitation", "post", (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        message.destroy();
                        message.success(data.statusMessage, 3);
                        this.addDefaultHandler();
                        this.getInvitations();
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }              
                }           
                this.setState({
                    isloading: false,
                });
                
    
            }, values);
        }else{
            values=   {
                "id": 0,
                "primary_Contact_First_Name": values.first_Name,
                "primary_Contact_Middle_Name":  values.middle_Name,
                "primary_Contact_Last_Name":  values.last_Name,
                "primary_Contact_Email":  values.email,
                "internal":true
             
              }
            this.api.invoke("UpsertAgencyInvite", "post", (data, success) => {
                
                if (success) {
                    if (data.statusCode === 200) {
                        message.destroy();
                        message.success(data.statusMessage, 3);
                        this.addDefaultHandler();
                        this.getInvitations();
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }              
                }           
                this.setState({
                    isloading: false,
                });
    
            }, values);
        }
       
    }
    AcceptInvite = (record) => {

        var data = {
            "contract_Id": record.contract_Id,
            "status": "PendingCompliance"

        }
        this.api.invoke("UpdateInvitaionStatus", "post", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {
                    message.destroy();
                    message.success(data.statusMessage, 3);

                }
                else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
                this.getInvitations();
            }
        }, data);
    }
    DeclineInvite = (record) => {
        var data = {
            "contract_Id": record.contract_Id,
            "status": "Declined"

        }
        this.api.invoke("UpdateInvitaionStatus", "post", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {
                    message.destroy();
                    message.success(data.statusMessage, 3);
                }
                else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
                this.getInvitations();
            }
        }, data);
    }
    getInvitations_ = () => {
        this.api.invoke("GetContractsInvitaions", "get", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {
                    const Contracts = data.data;
                    this.data_ = Contracts;
                    this.setState({ allInvitationsLoading: false });
                } else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
            }

        });
        // this.api.invoke("SubscriptionValidation", "get", (data, success) => {
        //     if (success) {
        //         if (data.statusCode === 200) {

        //             this.setState({ validation: data.data });
        //             this.setState({ allInvitationsLoading: false });
        //         } else {
        //             message.destroy();
        //             message.error(data.statusMessage, 3);
        //         }
        //     }
        // });
    }
    getInvitations = () => {
        this.api.invoke("GetBrokerInvitaions", "get", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {
                    const Contracts = data.data;
                    this.data = Contracts;
                } else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
            }
            this.setState({ allInvitationsLoading: false });

        }); 
       
    }
    render() {
        return (
            <Content>
                <div className="mi_main1">
                    <div className="mi_box">
                        <Row span={24}>
                            <Col span={18}>
                                <h4 className="mi_box_h4">Invitations</h4>
                            </Col>
                            <Col span={6}>
                                <img alt="example" style={{ height: '182px', marginTop: '-80px' }} src={img} />
                            </Col>
                        </Row>
                    </div>
                    <TableWrapper columns={this.columns} rowKey="id" data={this.state.allInvitationsLoading ? null : this.data} loading={this.state.allInvitationsLoading} title="Invitations" buttons={this.tableButtons} search={true} />
                    <TableWrapper columns={this.columns_} rowKey="id" data={this.state.allInvitationsLoading ? null : this.data_} loading={this.state.allInvitationsLoading}   search={true} />


                </div>
                {this.state.addInvite ? (
                    <Modal visible={this.state.addInvite} loading={this.state.isloading}>
                        <BrokerInvitation
                            closeDrawerHandler={this.addDefaultHandler}
                            width={500}
                            client={this.state.client}
                            submitHandler={this.addSubmitHandler}
                        />
                    </Modal>
                ) : null}
            </Content>

        );
    }
}
export default Invitations;